import { UseQueryOptions } from 'react-query'
import { getCurrentUser, getCurrentUserFromAuth0 } from '../api/users'
import { User } from '../types'
import { checkGravatarExists } from './gravatar'

export const userQueryKeys = {
  me: ['users', 'me'],
  userHasGravatar: (email: string) => ['users', 'gravatar', email]
}

export const usersMeQuery: UseQueryOptions<User, Error> = {
  queryKey: userQueryKeys.me,
  queryFn: async () => {
    // We always try to get the user from Accounts API first and if it fails, we fallback to Auth0
    try {
      return await getCurrentUser()
    } catch (error) {
      return await getCurrentUserFromAuth0()
    }
  },
  staleTime: Infinity,
  retry: 3,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
}

export const userHasGravatarQuery = (email: string) => ({
  queryKey: userQueryKeys.userHasGravatar(email),
  queryFn: () => checkGravatarExists(email),
  staleTime: Infinity
})
